<template>
	<div id="app">
		<div class="headdiv">
			<div class="wal">
				<div class="logo">
					<p>欢迎您来到成都市消毒协会官方网站</p>
					<div class="logo-title">
						<p>成都市消毒协会</p>
						<span>Chengdu disinfection Association</span>
					</div>
				</div>
				<div class="topbtn">
    <el-select v-model="searchType" placeholder="请选择" style="width: 120px; margin-right: 5px;">
        <el-option
            v-for="item in searchOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
    </el-select>
    <el-input placeholder="搜索内容" v-model="title" style="width: 250px;">
        <el-button slot="append" icon="el-icon-search" type="primary" @click="clickSub">搜索</el-button>
    </el-input>
</div>
				<div class="entrance">
					<!-- <a target="_blank" href="http://member.cdda2021.com">消毒协会办公系统入口</a> -->
				</div>
			</div>
		</div>
		<div class="layout">
			<div class="layout-cell">
				<div class="navber">
					<el-menu router :default-active="this.$router.path" class="el-menu-demo" mode="horizontal"
							 background-color="#066FC4" text-color="#fff" active-text-color="#ffd04b">
						<el-menu-item index="/">首页</el-menu-item>
						<el-submenu index="1">
							<template slot="title">关于协会</template>
							<el-menu-item index="/brief">协会简介</el-menu-item>
							<el-menu-item index="/rules">协会章程</el-menu-item>
							<el-menu-item index="/leader">协会领导</el-menu-item>
							<el-menu-item index="/framework">协会架构</el-menu-item>
						</el-submenu>
						<el-submenu index="3">
							<template slot="title">协会动态</template>
							<el-menu-item index="/notice">协会公告</el-menu-item>
							<el-menu-item index="/dynamic">协会动态</el-menu-item>
							<el-menu-item index="/DisinfectionTraining">消毒知识和技能培训</el-menu-item>
							<el-menu-item index="/DisinfectionTrainingNew">消毒产品相关培训</el-menu-item>
							<el-menu-item index="/secondaryEducation">继教项目</el-menu-item>
							<el-menu-item index="/bzd">感控管理培训</el-menu-item>
						</el-submenu>
						<el-submenu index="4">
							<template slot="title">行业资讯</template>
							<el-menu-item index="/regulations">政策法规</el-menu-item>
							<el-menu-item index="/standard">行业要闻</el-menu-item>
              <el-menu-item index="/kepu">科普知识</el-menu-item>
						</el-submenu>
						<el-submenu index="5">
							<template slot="title">备案管理</template>
							<el-menu-item index="/listOf">消毒服务机构</el-menu-item>
							<el-menu-item index="/publicityList">消毒检测评价机构备案公示名单</el-menu-item>
							<el-menu-item index="/filingProcess">备案流程</el-menu-item>
							<el-menu-item index="/productFiling">产品备案</el-menu-item>
						</el-submenu>
						<el-submenu index="6">
							<template slot="title">会员风采</template>
							<el-menu-item index="/memberInformation">会员名单</el-menu-item>
							<el-menu-item index="/industry">会员展示</el-menu-item>
							<el-menu-item index="/credit">会员资讯</el-menu-item>
						</el-submenu>

						<el-submenu index="7">
							<template slot="title">产品技术服务</template>
							<el-menu-item index="/companyList">产品公司列表</el-menu-item>
							<el-menu-item index="/productList">产品列表</el-menu-item>
						</el-submenu>

						<el-submenu index="8">
							<template slot="title">申请入会</template>
							<el-menu-item index="/law">申请入会</el-menu-item>
							<el-menu-item index="/information">申请流程</el-menu-item>
						</el-submenu>
						<el-submenu index="9">
							<template slot="title">学员成绩</template>
							<el-menu-item index="/scoreShow">考试成绩合格查询</el-menu-item>

						</el-submenu>
						<el-submenu index="10">
							<template slot="title">党建工作</template>
							<el-menu-item index="/workDynamics">工作动态</el-menu-item>
							<el-menu-item index="/studyFiles">学习文件</el-menu-item>
						</el-submenu>
						<el-submenu index="11">
							<template slot="title">下载中心</template>
							<el-menu-item index="/industryNews">协会文件</el-menu-item>
							<el-menu-item index="/associationNews">行业资料</el-menu-item>
							<el-menu-item @click="openStandardQuery">标准查询</el-menu-item>
						</el-submenu>
						<el-submenu index="12">
							<template slot="title">联系我们</template>
							<el-menu-item index="/mode">联系方式</el-menu-item>
						</el-submenu>
						<!-- 注释掉之前添加的一级菜单项 -->
						<!-- <el-menu-item index="/productService">产品技术服务</el-menu-item> -->
					</el-menu>
				</div>
			</div>
		</div>
		<router-view/>

		<div class="lay-cell">
			<a href="javascript:;" v-if="btnFlag" class="topa" @click="backTop"></a>
			<div class="content">
				<p style="margin-top:20px;">
					<span style="width:200px;">主管单位：{{ dataInformation.competentUnit }}</span>
					<span style="width:200px;margin-left:35px;">承办单位：{{ dataInformation.undertaker }}</span>
				</p>
				<p>
					<span style="width:200px;">地 址：{{ dataInformation.address }}</span>
					<span style="width:200px;margin-left:35px;">邮编：{{ dataInformation.postcode }}</span>
					<span style="width:200px;margin-left:35px;">备案号：{{ dataInformation.recordNumber }}</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			dataInformation: '',
			btnFlag: true,
			title: undefined,
			searchType: 'fullText',
			searchOptions: [
				{ value: 'fullText', label: '全文搜索' },
				{ value: 'product', label: '产品搜索' }
			]
		}
	},
	created() {
		this.getInformation();
	},
	mounted() {
		window.addEventListener('scroll', this.scrollToTop)
	},
	destroyed() {
		window.removeEventListener('scroll', this.scrollToTop)
	},
	methods: {
		// 获取搜索
		clickSub() {
			if (this.searchType === 'fullText') {
				this.$axios.get('/websiteData/title/allList', {
					params: this.queryParams
				}).then(res => {
					this.dataDynamic = res.data.rows;
					this.total = res.data.total;
				})
				this.$router.push({
					path: '/searchsList',
					query: {
						title: this.title,
					}
				})
			} else if (this.searchType === 'product') {
				// 如果当前已经在产品列表页面，先重置路由，然后再跳转
				if (this.$route.path === '/productList') {
					this.$router.replace('/').then(() => {
						this.$router.push({
							path: '/productList',
							query: {
								productName: this.title
							}
						});
					});
				} else {
					this.$router.push({
						path: '/productList',
						query: {
							productName: this.title
						}
					});
				}
			}
		},
		// 获取的页脚数据内容
		getInformation() {
			this.$axios.get('/websiteData/title/getInformation').then(res => {
				this.dataInformation = res.data.data;
			})
		},
		// 点击图片回到顶部方法，加计时器是为了过渡顺滑
		backTop() {
			const that = this
			let timer = setInterval(() => {
				let ispeed = Math.floor(-that.scrollTop / 5)
				document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
				if (that.scrollTop === 0) {
					clearInterval(timer)
				}
			}, 16)
		},
		// 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
		scrollToTop() {
			const that = this
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			that.scrollTop = scrollTop
			if (that.scrollTop > 60) {
				that.btnFlag = true
			} else {
				that.btnFlag = false
			}
		},
		// 打开标准查询网址
		openStandardQuery() {
			window.open('https://std.samr.gov.cn/', '_blank')
		}
	}
}
</script>

<style lang="scss">
#app {
	position: relative;

	.headdiv {
		height: 197px;
		background: url('./assets/image/head.gif') top repeat-x;

		.wal {
			position: relative;
			max-width: 1200px;
			width: 100%;
			margin: 0 auto;
			height: 197px;
			padding: 0 20px;
			background: url('./assets/image/head.gif') top repeat-x;

			.logo {
				position: absolute;
				left: 20px;
				top: 30px;

				.logo-title {
					color: rgb(6, 111, 196);

					p {
						font-size: 38px;
						letter-spacing: 8px;
					}

					span {
						font-size: 18px;
					}
				}

				p {
					letter-spacing: 4px;
					color: rgb(6, 111, 196);
				}
			}

			.topbtn {
				width: 320px;
				height: 115px;
				position: absolute;
				z-index: 10;
				top: 24px;
				right: 0px;
				display: flex;
				align-items: center;
			}

			.entrance {
				position: absolute;
				top: 25px;
				right: 20px;
				font-size: 14px;
				z-index: 9999;
				cursor: pointer;

				a {
					color: rgb(6, 111, 196);
				}
			}
		}
	}

	.lay-cell {
		.topa {
			width: 100%;
			height: 43px;
			overflow: hidden;
			background: url('assets/image/topA.png') center top no-repeat;
			border-bottom: #0977d1 solid 1px;
			display: block;
			background-color: #FFF;
			margin: 0 auto;
		}

		.link {
			text-align: center;
			padding: 35px 0 15px 0;

			a {
				color: #333;
				outline: none;
				text-decoration: none;
				font-size: 14px;
				padding: 0 12px;
			}
		}

		.content {
			max-width: 1200px;
			width: 100%;
			margin: 0 auto 30px auto;
			padding: 0 20px;
			text-align: center;
			color: #666;
			font-size: 12px;
			line-height: 20px;
		}
	}

	.layout {
		width: 100%;
		overflow: hidden;
		position: absolute;
		top: 137px;
		left: 0px;
		box-shadow: 0 2px 8px rgba(0,0,0,0.1);

		.layout-cell {
			max-width: 1200px;
			width: 100%;
			margin: 0 auto;
			height: 60px;
			padding: 0 20px;

			.navber {
				.el-menu {
					border-radius: 0;
					box-shadow: none;
					transition: all 0.3s ease;
					display: flex;
					justify-content: space-between;
					width: 100%;

					.el-menu-item {
						transition: all 0.3s ease;
						border-bottom: 3px solid transparent;
						flex: 1;
						text-align: center;
						justify-content: center;

						&:hover {
							border-bottom-color: #ffd04b;
							transform: translateY(-2px);
						}
					}

					.el-submenu {
						transition: all 0.3s ease;
						flex: 1;

						.el-submenu__title {
							border-bottom: 3px solid transparent;
							transition: all 0.3s ease;
							justify-content: center;
							text-align: center;

							&:hover {
								border-bottom-color: #ffd04b;
								transform: translateY(-2px);
							}
						}
					}
				}
			}
		}
	}
}

.brief .row .w750 .pageBox2 .about ul {
	width: 100%;
}

.brief .row .w750 .pageBox2 .about ul li {
	display: flex;
}

.brief .row .w750 .pageBox2 .about ul li a {
	width: 75%;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
</style>
